import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import UIContext from 'components/Utils/UIContext';
import { FishboneLinkSection } from './FishboneLinkSection';

interface FishboneGeneralLinksProps {
	// La branche ou sous-arete selectionnee (porte les champs *Links)
	selection: any;
	nodeType: 'branch' | 'item';
	scenario: any;
	select?: Function;
	risks?: any[];
	stakes?: any[];
	indicators?: any[];
}

// Sections inline de liens affichees dans le GeneralTab d'une branche /
// sous-arete : Risques, Ouvertures (meme table risk filtree isOpportunity),
// Enjeux, Indicateurs. Les parties prenantes sont dans un onglet dedie.
export const FishboneGeneralLinks = (props: FishboneGeneralLinksProps) => {
	const { t } = useTranslation();
	const uiContext = useContext(UIContext);
	const [open, setOpen] = useState({
		risks: true,
		openings: true,
		stakes: true,
		indicators: true
	});
	const toggle = (k: keyof typeof open) =>
		setOpen((o) => ({ ...o, [k]: !o[k] }));

	const common = {
		selection: props.selection,
		nodeType: props.nodeType,
		scenario: props.scenario,
		select: props.select,
		disabled: !uiContext.canEdit
	};

	return (
		<>
			<FishboneLinkSection
				{...common}
				target="indicator"
				items={props.indicators || []}
				title={t('models.item.fields.indicators.name')}
				visible={open.indicators}
				onToggleVisible={() => toggle('indicators')}
			/>
			<FishboneLinkSection
				{...common}
				target="stake"
				items={props.stakes || []}
				title={t('models.item.fields.stakes.name')}
				visible={open.stakes}
				onToggleVisible={() => toggle('stakes')}
			/>
			<FishboneLinkSection
				{...common}
				target="risk"
				items={props.risks || []}
				filter={(r) => !r.isOpportunity}
				title={t('models.item.fields.risks.name')}
				visible={open.risks}
				onToggleVisible={() => toggle('risks')}
			/>
			<FishboneLinkSection
				{...common}
				target="risk"
				items={props.risks || []}
				filter={(r) => !!r.isOpportunity}
				title={t('models.item.fields.opportunities.name')}
				visible={open.openings}
				onToggleVisible={() => toggle('openings')}
			/>
		</>
	);
};

export default FishboneGeneralLinks;
